import { useQuery } from "@tanstack/react-query";
import { getTargetsUrl } from "api";
import { QUERY_KEYS } from "consts";

export const useGetTargetsUrl = () =>
  useQuery<{ embedUrl: string }>([QUERY_KEYS.TARGETS_DASHBOARD_URL], getTargetsUrl);
